import { Deserializable } from '../protocols/deserializable';
import { Attachment } from './attachment';
import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';

export class SubmissionSpousalWaiver implements Deserializable {
  public id!: string;
  public governingJurisdictionId!: number | null;
  public governingJurisdiction: GoverningJurisdictionType | null = null;
  public accountId!: number | null;
  public signedDate!: string | null;
  public effectiveDate!: string | null;
  public attachment!: Attachment | null;

  public onDeserialize(): void {
    if (this.attachment) {
      this.attachment = window.injector.Deserialize.instanceOf(Attachment, this.attachment);
    }
    if (this.governingJurisdiction) {
      this.governingJurisdiction = window.injector.Deserialize.instanceOf(
        GoverningJurisdictionType,
        this.governingJurisdiction
      );
    }
  }
}
